import ReactQuill from 'react-quill';

import './texteditor.css';

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{ 'color': [] }, { 'background': [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
    ],
    ['link'],
    ['clean'],
  ],
};

export default function RichTextEditor({ value, onChange, modules }) {
  function handleChange(content, delta, source, editor) {
    if (editor.getLength() === 0) {
      onChange('');
      return;
    }

    onChange(content);
  }

  return (
    <ReactQuill
      theme="snow"
      modules={modules || defaultModules}
      value={value}
      onChange={handleChange}
    />
  );
}
